import { merge } from '../../helper';

import * as exBootstrap from '../../bootstrap';
import * as exToast from '../../components/toast';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): Record<string, any> {
    // Default Config
    const defConfig: Record<string, any> = {};

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    let elements: Record<string, any>;

    // Create element (notify)
    const notify = exToast.create({
        merge: defConfig,
    });
    elements = notify;

    // ------------------------------------------------------------------------

    // Settings
    settings(elements, defConfig);

    // Events
    events(elements, defConfig);

    // ------------------------------------------------------------------------

    // Return
    return elements;
}

function settings(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // Do nothing
}

function events(elements: Record<string, any>, config: Record<string, any> = {}): void {
    // Create event (hidden toast)
    elements.element.addEventListener('hidden.bs.toast', function (this: any): any {
        // Get element (toast container)
        const elToastContainer = this.closest('.toast-container');

        removeNotify(this);

        // If there is element (toast container)
        if (elToastContainer?.childNodes.length === 0) {
            elToastContainer.remove();
        }
    });
}

function removeNotify(element: HTMLElement, config: Record<string, any> = {}): void {
    // Get bootstrap type
    const bsType = exBootstrap.getCreateInstance('Toast', element);
    if (!bsType) {
        return;
    }

    exToast.dispose(element, config);
    element.remove();
}

// ----------------------------------------------------------------------------

export { create };
